<template>
  <Transition name="fade-fast">
    <Loader v-if="!$beet.isReady" />
  </Transition>
  <template v-if="$beet.isReady">
    <SiteNav />
    <div class="app__content">
      <router-view v-slot="{ Component }">
        <transition name="fade-fast" mode="out-in">
          <component :is="Component" :key="$route.path" />
        </transition>
      </router-view>
    </div>
    <Footer />
    <Popup />
  </template>
</template>

<script>
import Popup from '@/components/modal/Popup.vue'
import SiteNav from '@/components/navigation/SiteNav.vue'
import Footer from '@/components/sections/Footer.vue'
import Loader from '@/components/small/Loader.vue'
import { useLangRouter } from '@/extensions/langRouter'

export default {
  name: 'App',
  components: {
    Footer,
    Loader,
    Popup,
    SiteNav,
  },
  setup() {
    useLangRouter()
  },
  watch: {
    '$i18n.locale': {
      handler: function (to) {
        this.$beet.fetchCoreData(to)
      },
      immediate: true,
    },
  },
}
</script>
